import { useCallback, useState } from "react";
import BetaBranchOptInBanner from "app/pages/website-analysis/TrafficAndEngagement/BetaBranch/BetaBranchOptInBanner";
import BetaBranchFeedbackSurvey from "app/pages/website-analysis/TrafficAndEngagement/BetaBranch/BetaBranchFeedbackSurvey";
import { ThankYouModal } from "pro-features/components/OptIn/components/ThankYouModal";
import { ThankYouModalImage } from "app/pages/website-analysis/TrafficAndEngagement/BetaBranch/ThankYouModalImage";
import { allTrackers } from "app/services/track/track";
import { ResetBetaBranchFlagModal } from "app/pages/website-analysis/TrafficAndEngagement/BetaBranch/ResetBetaBranchFlagModal";
import { connect } from "react-redux";
import { toggleResetBetaBranchModal } from "app/actions/commonActions";
import { swSettings } from "app/common/services/swSettings";
import { BetaBranchContext } from "./BetaBranchContext";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { GAWizardModal } from "app/components/GA-verify/GAWizardModal";
import { chosenSites } from "app/common/services/chosenSites";

const BetaBranchContainerComponent = (props) => {
    const { isResetBetaModalOpen } = props;
    const [isBetaBranchFeedbackSurveyOpen, setIsBetaBranchFeedbackSurveyOpen] = useState(false);
    const [isBetaBranchThankUModalOpen, setIsBetaBranchThankUModalOpen] = useState(false);
    const [isGAWizardModalOpen, setIsGAWizardModalOpen] = useState<boolean>(false);
    const onCloseThankUModal = useCallback(() => {
        setIsBetaBranchThankUModalOpen(false);
    }, []);

    const onGAButtonClick = useCallback(() => {
        setIsBetaBranchThankUModalOpen(false);
        setIsGAWizardModalOpen(true);
        allTrackers.trackEvent("Connect GA", "open", `Connect GA`);
    }, []);

    const onGAWizardModalClose = () => setIsGAWizardModalOpen(false);

    const { hasGaToken, privacyStatus } = chosenSites.getPrimarySite() as any;

    // Disables GA. this property comes from a special claim called "NoGA"
    const isGADisabled = swSettings.user.disableGA;

    const thankYouModalProps = {
        title: "beta.branch.feedback.thank.you.modal.title",
        closeLabel: "beta.branch.feedback.thank.you.modal.close.label",
        gaButtonLabel: "beta.branch.feedback.thank.you.modal.gabutton.label",
        isGADisabled: isGADisabled,
        ThankUModalImage: ThankYouModalImage,
        hasGaToken,
        privacyStatus,
        onCloseClick: onCloseThankUModal,
        onGAButtonClick,
    };

    const onCloseResetClick = useCallback(() => {
        props.closeResetBetaBranchModal();
    }, []);

    const onContinueResetModalClick = useCallback(() => {
        props.closeResetBetaBranchModal();
        proNavigator.updateParams(isResetBetaModalOpen.updateParams);
    }, [isResetBetaModalOpen]);

    const resetBetaBranchProps = {
        title: isResetBetaModalOpen?.useDurationTitle
            ? "beta.branch.reset.modal.title"
            : "beta.branch.reset.modal.country.title",
        subtitle: "beta.branch.reset.modal.subtitle",
        onCloseClick: onCloseResetClick,
        onContinueClick: onContinueResetModalClick,
        continueLabel: "beta.branch.reset.modal.continue.label",
        closeLabel: "beta.branch.reset.modal.close.label",
    };
    return (
        <BetaBranchContext.Provider
            value={{
                isBetaBranchFeedbackSurveyOpen,
                setIsBetaBranchFeedbackSurveyOpen,
                setIsBetaBranchThankUModalOpen,
            }}
        >
            <BetaBranchOptInBanner />
            <BetaBranchFeedbackSurvey />
            <ThankYouModal
                isOpen={isBetaBranchThankUModalOpen}
                {...thankYouModalProps}
            />
            <GAWizardModal
                isOpen={isGAWizardModalOpen}
                onClose={onGAWizardModalClose}
            />
            <ResetBetaBranchFlagModal
                isOpen={isResetBetaModalOpen?.isOpen}
                {...resetBetaBranchProps}
            />
        </BetaBranchContext.Provider>
    );
};

function mapDispatchToProps(dispatch) {
    return {
        closeResetBetaBranchModal: () => {
            dispatch(toggleResetBetaBranchModal(false, undefined, true));
        },
    };
}

function mapStateToProps({ common: { isResetBetaModalOpen } }) {
    return {
        isResetBetaModalOpen,
    };
}

export const BetaBranchContainer = connect(mapStateToProps, mapDispatchToProps)(BetaBranchContainerComponent);
